import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { isSuperAdmin } from 'app/shared/utils';

@Injectable({ providedIn: 'root' })
export class SuperAdminGuard implements CanActivate, CanLoad {
    constructor(private readonly router: Router) {}

    canActivate(_route: unknown, _state: RouterStateSnapshot): boolean | UrlTree {
        return isSuperAdmin() || this.router.parseUrl('/dashboard');
    }

    canLoad(_route: Route, _segments: UrlSegment[]): boolean | UrlTree {
        return isSuperAdmin() || this.router.parseUrl('/dashboard');
    }
}
